import { RelativeUrl } from "@adora/shared";
import fetcher from "@adora/shared/utils/fetch";

export const downloadCaptions = async (id: number): Promise<Blob> => {
  const { presigned_url } = await fetcher<{ presigned_url: string }>(`${RelativeUrl}/batches/${id}/captions`);
  const response = await fetch(presigned_url);
  return await response.blob();
};
